import { actionsTypes as types } from "../actions/widgetConfigActions";
import { actionsTypes as userTypes } from "../actions/userActions";
import { actionsTypes as devicesTypes } from "../actions/devicesActions";

import {
  widgetGridDimensionsForWidgetTypes,
  specialSettingsForWidgetTypes,
  //GRID_SIZE
} from "../helpers/constants";

// Subreducer for user settings
import widgetSettingsReducer from "./widgetSettingsReducer";

const INITIAL_STATE = {};

var INITIAL_WIDGET_SETTINGS = {
  border_left: true,
  border_right: true,
  border_top: true,
  border_bottom: true
};

// These are specific to the widget type
// make implicit through loop
var INITIAL_SPECIAL_WIDGET_SETTINGS = {
  radialgauge: {
    min_value: 0,
    max_value: 100,
    [specialSettingsForWidgetTypes["radialgauge"][2].name] : specialSettingsForWidgetTypes["radialgauge"][2].default,
    [specialSettingsForWidgetTypes["radialgauge"][3].name] : specialSettingsForWidgetTypes["radialgauge"][3].default,
    [specialSettingsForWidgetTypes["radialgauge"][4].name] : specialSettingsForWidgetTypes["radialgauge"][4].default,
  },
  lineargauge: {
    min_value: 0,
    max_value: 100,
    [specialSettingsForWidgetTypes["lineargauge"][2].name] : specialSettingsForWidgetTypes["lineargauge"][2].default,
    [specialSettingsForWidgetTypes["lineargauge"][3].name] : specialSettingsForWidgetTypes["lineargauge"][3].default,
    [specialSettingsForWidgetTypes["lineargauge"][4].name] : specialSettingsForWidgetTypes["lineargauge"][4].default,

  },
  linechart: {
    [specialSettingsForWidgetTypes["linechart"][0].name]:
      specialSettingsForWidgetTypes["linechart"][0].default,
    [specialSettingsForWidgetTypes["linechart"][1].name]:
      specialSettingsForWidgetTypes["linechart"][1].default,
      
  },
  imageview: {
    [specialSettingsForWidgetTypes["imageview"][0].name]:
    specialSettingsForWidgetTypes["imageview"][0].default,
  [specialSettingsForWidgetTypes["imageview"][1].name]:
    specialSettingsForWidgetTypes["imageview"][1].default
  }
};

//console.log("888", INITIAL_SPECIAL_WIDGET_SETTINGS)

const widgetConfigReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_WIDGET_SETTINGS_PROP:
      var { widgetid } = action;
      return {
        ...state,
        [widgetid]: {
          ...state[widgetid],
          widgetSettings: widgetSettingsReducer(
            state[widgetid].widgetSettings,
            action
          )
        }
      };

    case userTypes.RECEIVE_PERSISTET_WIDGET_CONFIG:
      // INJECT widgetSettings: INITIAL_WIDGET_SETTINGS here?
      console.log(
        "widgetConfigReducer RECEIVE_PERSISTET_WIDGET_CONFIG:",
        action
      );
      return action.widgetConfig;

    case types.ADD_WIDGET2DASHBOARD:
      var { widgetid, widget_type, gridOrigin, gridDimensions } = action;
      console.log("Reducer: ADD_WIDGET2DASHBOARD", widgetid, widget_type);

      let gridCoords = {
        gridx1: gridOrigin.gridx,
        gridy1: gridOrigin.gridy,
        gridx2: gridOrigin.gridx + gridDimensions.gridw,
        gridy2: gridOrigin.gridy + gridDimensions.gridh
      };

      let specialSettings = INITIAL_SPECIAL_WIDGET_SETTINGS[widget_type];
      let generalSettings = INITIAL_WIDGET_SETTINGS;

      return {
        ...state,
        [widgetid]: {
          widget_type,
          gridCoords,
          sensor_slots: [],
          widgetSettings: { ...generalSettings, ...specialSettings }
        }
      };

    case types.CONNECT_WIDGET2SENSOR:
      var { deviceid, sensorid, widgetid } = action;
      return {
        ...state,
        [widgetid]: {
          ...state[widgetid],
          sensor_slots: [
            ...state[widgetid].sensor_slots,
            {
              deviceid,
              sensorid
            }
          ]
        }
      };

    case types.DISCONNECT_WIDGET_FROM_SENSOR:
      var { widgetid, sensorid } = action;
      console.log("DISCONNECT_WIDGET_FROM_SENSOR called in reducer");
      let newState = {};
      if (state.hasOwnProperty(widgetid)) {
        const widget = state[widgetid];
        let newSensorSlots = widget.sensor_slots.filter(sensor_slot => {
          return sensor_slot.sensorid !== parseInt(action.sensorid);
        });
        newState[widgetid] = {
          ...state[widgetid],
          sensor_slots: newSensorSlots
        };
      }

      return { ...state, ...newState };

    case types.MOVE_WIDGET_ORIGIN:
      var { gridOrigin, widgetid } = action;

      var oldGridCoordinates = state[widgetid].gridCoords;
      var { gridx1, gridy1, gridx2, gridy2 } = oldGridCoordinates;
      var oldw = gridx2 - gridx1;
      var oldh = gridy2 - gridy1;

      var newGridCoordinates = {
        gridx1: gridOrigin.gridx,
        gridy1: gridOrigin.gridy,
        gridx2: gridOrigin.gridx + oldw,
        gridy2: gridOrigin.gridy + oldh
      };

      return {
        ...state,
        [widgetid]: {
          ...state[widgetid],
          gridCoords: newGridCoordinates
        }
      };

    case types.RESIZE_WIDGET:
      var { targetGridCoords, side, widgetid } = action;
      //console.log("Reducer RESIZE_WIDGET", targetGridCoords, side, widgetid);
      var oldGridCoordinates = state[widgetid].gridCoords;
      var newGridCoordinates = {};

      // TODO: Maybe factor this switch out to helpers
      switch (side) {
        case "right":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx2: targetGridCoords.gridx
          };
          break;
        case "left":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx1: targetGridCoords.gridx
          };
          break;
        case "top":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridy1: targetGridCoords.gridy
          };
          break;
        case "bottom":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridy2: targetGridCoords.gridy
          };
          break;
        case "topleft":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx1: targetGridCoords.gridx,
            gridy1: targetGridCoords.gridy
          };
          break;
        case "topright":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx2: targetGridCoords.gridx,
            gridy1: targetGridCoords.gridy
          };
          break;
        case "bottomleft":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx1: targetGridCoords.gridx,
            gridy2: targetGridCoords.gridy
          };
          break;
        case "bottomright":
          newGridCoordinates = {
            ...oldGridCoordinates,
            gridx2: targetGridCoords.gridx,
            gridy2: targetGridCoords.gridy
          };
          break;

        default:
          newGridCoordinates = oldGridCoordinates;
          break;
      }

      // Check, that new size is not smaller than intrinsic size
      let widgetType = "simplenumeric";
      try {
        widgetType = state[widgetid].widget_type;
      } catch (error) {
        console.error(error);
      }

      let newW = newGridCoordinates.gridx2 - newGridCoordinates.gridx1;
      let newH = newGridCoordinates.gridy2 - newGridCoordinates.gridy1;
      let minW = widgetGridDimensionsForWidgetTypes[widgetType].gridw;
      let minH = widgetGridDimensionsForWidgetTypes[widgetType].gridh;
      if (newW < minW || newH < minH) {
        newGridCoordinates = oldGridCoordinates;
        // TODO: maybe show a msg to the user, if this happens.
      }

      return {
        ...state,
        [widgetid]: {
          ...state[widgetid],
          gridCoords: newGridCoordinates
        }
      };

    case types.DELETE_WIDGET:
      const { [action.widgetid]: undefined, ...without } = state;
      console.log("REDUCER: DELETE WIDGET", without);
      return {
        ...without
      };

    // DELETE DEVICE AND DELETE SENSOR ACTIONS FROM DEVICE ACTIONS
    // Remove connections (entries in sensor slot) of widgets, that are connected to the deleted device or sensor
    // DISCONNECT_ALL_WIDGETS_FROM_DEVICE gets its own action in this reducer, because resetting a device only triggers a async server action!
    // the syntax with a 2nd case immediatly preceeding another one works like an OR expression between them! https://stackoverflow.com/a/52023566
    case devicesTypes.DELETE_DEVICE:
    case types.DISCONNECT_ALL_WIDGETS_FROM_DEVICE: {
      console.log("DISCONNECT_ALL_WIDGETS_FROM_DEVICE reducer called", action);
      let newState = {};

      for (const widgetid in state) {
        if (state.hasOwnProperty(widgetid)) {
          const widget = state[widgetid];
          let newSensorSlots = widget.sensor_slots.filter(sensor_slot => {
            return sensor_slot.deviceid !== parseInt(action.uid);
          });
          newState[widgetid] = {
            ...state[widgetid],
            sensor_slots: newSensorSlots
          };
        }
      }
      return newState;
    }


    case devicesTypes.DELETE_SENSOR: {
      let newState = {};
      for (const widgetid in state) {
        if (state.hasOwnProperty(widgetid)) {
          const widget = state[widgetid];
          let newSensorSlots = widget.sensor_slots.filter(sensor_slot => {
            return sensor_slot.sensorid !== parseInt(action.sensor_uid);
          });
          newState[widgetid] = {
            ...state[widgetid],
            sensor_slots: newSensorSlots
          };
        }
      }
      return newState;
    }



    default:
      return state;
  }
};

export default widgetConfigReducer;
